import React from 'react';
import ReactDOM from 'react-dom';
import drupalSettings from 'drupalSettings';
import Drupal from 'Drupal';
import buildUrl from 'build-url';
import Select from 'react-select';
import { DebounceInput } from 'react-debounce-input';
import ReactPaginate from 'react-paginate';
import withSessionStorage from './session-storage/withSessionStorage';

let API_URL = '/api/facilities';
if (drupalSettings.path.currentLanguage === 'fr') {
  API_URL = '/fr/api/facilities';
}

class FacilityItem extends React.Component {
  constructor(props) {
    super(props);
    this.goToFacility = this.goToFacility.bind(this);
  }
  goToFacility() {
    return window.location = this.props.facility.nothing;
  }
  render() {
    return (
      <div onClick={this.goToFacility} className="four-column-grid-item w-inline-block">
        <div className="four-column-grid-item-wrapper">
            <img src={this.props.facility.field_facility_image}
                 className="four-column-grid-item-image imgiximage"
                 alt={this.props.facility.title}/>
          <h4 className="four-column-grid-heading" dangerouslySetInnerHTML={{ __html: this.props.facility.title }}></h4>
        </div>
      </div>
    )
  }
}

class Facility extends React.Component {
  constructor(props) {
    super(props);
    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleLoadMore = this.handleLoadMore.bind(this);
    this.handleCategorySelect = this.handleCategorySelect.bind(this);
    this.clearAll = this.clearAll.bind(this);

    this.state = {
      facilities: [],
      search: '',
      page: 0,
      pageCount: 0,
      selectedCategories: null,
      categories: drupalSettings.facility.categories,
      showLoadMore: false,
      loading: true,
      hasFilters: false
    };

    this.facilityRef = null;
  }

  buildUrl() {
    var query = {
      'page': this.state.page,
      '_format': 'json'
    };

    if (this.state.search !== '') {
      query.title = this.state.search
    }

    if (this.state.selectedCategories !== null) {
      query['field_facility_category_target_id[]'] = this.state.selectedCategories.value
    }

    if (this.state.search !== '' || this.state.selectedCategories !== null) {
      this.setState({ hasFilters: true })
    } else {
      this.setState({ hasFilters: true })
    }

    this.setState({ loading: true })

    var url = buildUrl(API_URL, {
      queryParams: query
    });

    return url
  }

  componentDidMount() {
    this.setState(this.props.getStateFromSessionStorage(this), () => {
      console.log(this.props.getStateFromSessionStorage(this))
      if(this.props.getStateFromSessionStorage(this) === null){
        var defaultCat = {value: "119", label: "The Inside Connection"}
        if (drupalSettings.path.currentLanguage === 'fr'){
          defaultCat = {value: "119", label: "Voie piétonnière intérieur"}
        }
        this.handleCategorySelect(defaultCat)
      } else {
        this.updateFacilities()
      }

    });
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  updateFacilities(clear, scroll) {
    var url = this.buildUrl()

    if (clear) {
      this.setState({ facilities: [] })
    }

    fetch(url)
      .then(response => response.json())
      .then(data => {
        this.setState({
          facilities: this.state.facilities.concat(data.results),
          loading: false,
          pageCount: data.pager.pages
        })
      })

    if (scroll === true) {
      window.scrollTo(0, this.facilityRef.offsetTop)
    }
  }

  handleTitleChange(event) {
    this.setState({
      search: event.target.value,
      page: 0
    }, () => {
      this.updateFacilities(true)
    });
  }

  handleLoadMore(page) {
    this.setState(
      { page: (page.selected) ? parseInt(page.selected) : 0 },
      () => {
        this.updateFacilities(true, true)
      }
    );
  }

  clearAll() {
    this.setState(
      {
        search: '',
        selectedCategories: [],
        loading: true,
        page: 0
      },
      () => {
        this.updateFacilities(true)
      }
    );
  }

  handleCategorySelect(categories) {
    console.log(categories)
    this.setState(
      {
        selectedCategories: categories,
        page: 0
      },
      () => {
        this.updateFacilities(true)
      }
    )
  }

  render() {
    return (
      <div className="section-member-cards" ref={(ref) => this.facilityRef = ref}>
        <div className="blue-heading-block-tall">
          <div className="blue-heading-block-tall-container">
            <h2 className="blue-heading-header">{Drupal.t('Venues')}</h2>
            <div className="blue-heading-block-tall-bottom-row">
              <form className="member-search w-form">
                <DebounceInput
                  minLength={2}
                  debounceTimeout={500}
                  className="section-search-input w-input"
                  maxLength="256"
                  name="query"
                  placeholder={Drupal.t('Search')}
                  id="section-search"
                  type="search"
                  value={this.state.search}
                  onChange={this.handleTitleChange} />
              </form>
              <div className="form-block w-form">
                <div className="select-wrapper select-wrapper-single-item">
                  <Select
                    name="category-select"
                    placeholder={Drupal.t('Select category')}
                    value={this.state.selectedCategories}
                    onChange={this.handleCategorySelect}
                    options={drupalSettings.facility.categories}
                    className='react-select-container'
                    classNamePrefix="react-select"
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      border: 0,
                      colors: {
                        ...theme.colors,
                        primary25: "#FEC100",
                        primary: "#FEC100",
                        neutral20: "#FEC100"
                      },
                      spacing: {
                        ...theme.spacing,
                        menuGutter: 0
                      }
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="four-column-grid w-clearfix">
          {(this.state.loading !== true && this.state.hasFilters) ? <div className="clear-all-container"><a className="clear-all" onClick={this.clearAll}>{Drupal.t('Clear All')}</a></div> : null}

          <div className="four-column-grid-container">
            {this.state.facilities.map(function (facility, index) {
              return <FacilityItem facility={facility} key={index}></FacilityItem>;
            })}

            {(this.state.facilities.length === 0 && this.state.loading === false) ? <div className="no-results-found">{Drupal.t('No results found.')}</div> : null}

            {(this.state.loading === true) ? <div className="loading"><svg width="70px" height="70px" viewBox="140 -1 68 70" version="1.1" id="SJN_PHYhsG"><g id="rkHuwrY2jG" fillRule="evenodd"><g id="HJUuvrK3sf"><g id="rJPdPBFnoM_HkudSK2oz"><path d="M0.1640625,28.1757812 C5.79354297,33.2055813 11.3312056,35.7432439 16.7770503,35.788769 C22.222895,35.8342942 27.6687397,33.3884495 33.1145845,28.4512349 C39.1033043,33.9747803 44.909886,36.781362 50.5343296,36.87098 C56.1587732,36.960598 61.7832168,34.3361544 67.4076604,28.9976492 C73.8347605,35.0245907 79.9290891,38.1189193 85.6906461,38.280635 C91.4522032,38.4423507 97.2137602,35.6807936 102.975317,29.9959639 C109.444473,35.7527492 115.437072,38.7453478 120.953113,38.9737596 C126.469154,39.2021713 131.985196,36.6861299 137.501237,31.4256352 C143.143013,36.0387188 148.515214,38.4109199 153.617841,38.5422385 C158.720467,38.6735571 163.823093,36.5709309 168.925719,32.2343598 C174.985169,37.9062501 180.86526,40.7863407 186.565991,40.8746315 C192.266722,40.9629222 197.967453,38.2621911 203.668184,32.7724381 C209.227767,37.9814772 214.823277,40.5769865 220.454712,40.5589659 C226.086148,40.5409454 231.717583,37.9095099 237.349018,32.6646595 C243.480762,39.422327 249.809573,42.7511384 256.335453,42.6510937 C262.861332,42.5510491 269.387212,39.0251696 275.913091,32.0734552 C281.933116,37.6303339 287.759216,40.4564339 293.391391,40.5517552 C299.023567,40.6470765 304.655742,38.0149012 310.287917,32.6552291 C316.005362,38.9498739 322.064831,42.0093431 328.466325,41.8336367 C334.867819,41.6579303 341.269313,38.2564362 347.670807,31.6291543 C353.197442,36.7591832 358.754763,39.3165046 364.342772,39.3011187 C369.930781,39.2857328 375.518789,36.697724 381.106798,31.5370922" id="rJPdPBFnoM" /></g><circle id="HkuuPrFnoG" cx="173.5" cy="33.5" r="33.5" /></g></g></svg></div> : null}
          </div>

          {this.state.pageCount > 1 ?
            <ReactPaginate
              previousLabel={'previous'}
              nextLabel={'next'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={this.state.pageCount}
              marginPagesDisplayed={0}
              pageRangeDisplayed={3}
              onPageChange={this.handleLoadMore}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
              initialPage={this.state.page}
              forcePage={this.state.page}
              disableInitialCallback={true}
            />
            : null}
        </div>
      </div>
    )
  }
}

Facility.sessionStorageKeys = ['selectedCategories', 'page', 'search'];
Facility.sessionStorageNamespace = 'facility';

Facility = withSessionStorage(Facility);

export default Facility;
